import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { FindMediaByLabellPipe } from '@df/ui/common/find-media-by-label.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { NProductViewLayout, Product } from '../../../product.decorator';
import { ProductViewDimensionsAndDetailsComponent } from '../../product-view-dimensions-and-details.component';

export const DIMENSIONS_MODAL_RIGHT_ID = 'dimensionsAndDetailsModalRight';

@Component({
    selector: 'product-view-dimensions-and-details-modal-right',
    templateUrl: './product-view-dimensions-and-details-modal-right.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FindMediaByLabellPipe,
        ImageModule,
        ProductViewDimensionsAndDetailsComponent
    ]
})
export class ProductViewDimensionsAndDetailsModalRightComponent extends UiComponent {
    readonly content = input.required<NProductViewLayout.IBlockDataContent>();
    readonly product = input.required<Product<IProductDataV3>>();
}
